/**
 * 安全的 Storage 工具
 * 處理 Chrome 阻擋 localStorage 的情況
 */

// 檢查 localStorage 是否可用
function isStorageAvailable(): boolean {
    try {
        const test = '__storage_test__'
        localStorage.setItem(test, test)
        localStorage.removeItem(test)
        return true
    } catch (e) {
        return false
    }
}

// 記憶體備份存儲（當 localStorage 不可用時）
const memoryStorage: Record<string, string> = {}

export const storage = {
    getItem(key: string): string | null {
        try {
            if (isStorageAvailable()) {
                return localStorage.getItem(key)
            }
            return memoryStorage[key] || null
        } catch (e) {
            console.warn('Storage getItem failed:', e)
            return memoryStorage[key] || null
        }
    },

    setItem(key: string, value: string): void {
        try {
            if (isStorageAvailable()) {
                localStorage.setItem(key, value)
            }
            // 同時保存到記憶體備份
            memoryStorage[key] = value
        } catch (e) {
            console.warn('Storage setItem failed, using memory storage:', e)
            memoryStorage[key] = value
        }
    },

    removeItem(key: string): void {
        try {
            if (isStorageAvailable()) {
                localStorage.removeItem(key)
            }
            delete memoryStorage[key]
        } catch (e) {
            console.warn('Storage removeItem failed:', e)
            delete memoryStorage[key]
        }
    },

    clear(): void {
        try {
            if (isStorageAvailable()) {
                localStorage.clear()
            }
            Object.keys(memoryStorage).forEach(key => delete memoryStorage[key])
        } catch (e) {
            console.warn('Storage clear failed:', e)
            Object.keys(memoryStorage).forEach(key => delete memoryStorage[key])
        }
    }
}
